// extracted by mini-css-extract-plugin
export default {"container":"loadingIndicator_container__q-YEd"};